import { Skeleton } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { IntercultureSatImagesPage } from '@interculture';

export const Route = createFileRoute(
  '/_app/interculture_/$crop/$formId/result/sat-images',
)({
  component: IntercultureSatImagesPage,
  pendingComponent: () => <Skeleton h="100%" />,
});
